module.exports = __webpack_public_path__ + "img/baijia-icon.5335c88a.png";